import React from 'react';
import GrowniverseLogo from "../Photos/Logo/growniverse-logo-full-bordered.svg";
import { Link } from 'react-router-dom';
const PrivacyPolicySection = () => {
    return (
        <section>
            <div style={{ padding: "10px" }}>
                <h5 style={{color:"white"}}>Growniverse Privacy Policy</h5>
                <div className="privacy-policy">
                    <p>
                        At Growniverse, we value the trust that our students place in us when they join our Universe.
                        This privacy policy explains how Growniverse collects, uses, and protects the personal information of students enrolling in our courses.
                    </p>

                    <h6 style={{color:"white"}}>What Personal Information We Collect</h6>
                    <p>
                        <b>We collect the following personal information from students:</b><br />
                        1.1 Name and Email Address: We collect name and email address when students register for courses.<br />
                        1.2 Password: We collect a password to secure student accounts.<br />
                        1.3 Payment Information: We collect payment information, such as email address for payments or bank account details, to process course fees and refunds.<br />
                        1.4 Website/Portfolio URL: We may collect a website or portfolio URL when provided by students for course-related purposes.<br />
                        1.5 IP Address: We collect the IP address to help secure accounts and monitor activity related to course access.<br />
                    </p>

                    <h6 style={{color:"white"}}>How We Use Personal Information</h6>
                    <p>
                        <b>We use personal information for these purposes:</b><br />
                        2.1 Course Administration: To manage student registrations, track course progress, and provide access to course materials.<br />
                        2.2 Communication: To communicate with students, including sending course updates, newsletters, receipts, and important notices.<br />
                        2.3 Payment Processing: To process course fees, refunds, and other payments.<br />
                    </p>

                    <h6 style={{color:"white"}}>How We Protect Personal Information</h6>
                    <p>
                        <b>We take reasonable measures to protect personal information from unauthorized access, use, or disclosure, including:</b><br />
                        3.1 SSL Encryption: We use SSL encryption to protect personal information transmitted over the internet.<br />
                        3.2 Firewalls and Access Controls: We use firewalls and access controls to restrict access to personal information.<br />
                        3.3 Data Backup and Recovery: We regularly back up personal information and maintain a disaster recovery plan.<br />
                    </p>

                    <h6 style={{color:"white"}}>Sharing Personal Information</h6>
                    <p>
                        <b>We do not sell personal information. We may share information with service providers only as needed to deliver our services:</b><br />
                        4.1 Payment Processors: We share payment information with payment processors to process course fees and refunds.<br />
                        4.2 Email Service Providers: We share email addresses with email service providers to send course-related communications and updates.<br />
                    </p>

                    <h6 style={{color:"white"}}>Student Rights</h6>
                    <p>
                        <b>Students have the following rights:</b><br />
                        5.1 Right to Access: Students have the right to access their personal information.<br />
                        5.2 Right to Correct: Students have the right to correct inaccurate personal information.<br />
                    </p>

                    <h6 style={{color:"white"}}>Changes to This Policy</h6>
                    <p>
                        <b>We may modify or update this privacy policy at any time. When we make changes, we will update this page.</b>
                    </p>

                    <h6 style={{color:"white"}}>Contact Us</h6>
                    <p>
                        <b>If you have any questions or concerns about this privacy policy, please contact us at:</b><br />
                        Mail us: <a href="mailto:admin@growniverse.com" target="_blank" style={{color:"white"}}>admin@growniverse.com</a><br />
                    </p>

                    <p>
                        By enrolling in Growniverse courses, students acknowledge that they have read, understood, and agree to this privacy policy.
                    </p>
                </div>

                <img src={GrowniverseLogo} width={"20%"} alt='Growniverse' />
                <p>
                    GROWNIVERSE<br />
                    A UNIVERSE WHERE YOU GROW
                </p>
            </div>
        </section>
    );
};

export default PrivacyPolicySection;
